import styled from "styled-components";
import backgroundImg from "../../assets/images/notesBg.jpg";

export const Styles = styled.div`
  background: var(--primary-light);
  overflow: hidden;
  width: 100vw;

  @media (min-width: 768px) {
    --panel-width: 30vw;
    --sidebar-width: 5rem;
    height: 100vh;
  }

  @media (max-width: 768px) {
    --panel-width: 100vw;
    --sidebar-width: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  .main-content {
    transition: 0.2s ease-in-out;

    @media (min-width: 768px) {
      margin-right: var(--sidebar-width);
      padding: ${(props) => (props.panelVisible ? "0 var(--panel-width) 0 0" : "0")};
      width: calc(100% - 5rem);
      position: absolute;
      display: flex;
      height: 100%;
    }

    @media (max-width: 768px) {
      width: 100%;
      height: ${(props) => (props.panelVisible ? "0" : props.secondaryContent ? "45vh" : "90vh")};
    }
  }

  .feedback-graph {
    position: absolute;

    @media (min-width: 768px) {
      margin-right: var(--sidebar-width);
      padding: ${(props) => (props.panelVisible ? "0 var(--panel-width) 0 0" : "0")};
      width: calc(100% - 5rem);
      display: flex;
      height: 100%;
    }

    @media (max-width: 768px) {
      width: 100%;
      height: ${(props) => (props.panelVisible ? "0" : "45vh")};
    }
  }

  .secondary-content {
    display: flex;
    flex-direction: column;

    transition: all 0.2s ease-in-out;
    z-index: 1;

    resize: both;
    //overflow: auto;

    @media (min-width: 768px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 35%;
      aspect-ratio: 16/9;
      border-radius: 0.5em;
    }

    @media (max-width: 768px) {
      width: 100%;
      height: ${(props) => (props.panelVisible ? "0" : "45vh")};
    }
  }

  .waiting {
    border: 3px solid var(--primary-dark);
    background: var(--accent-primary-dark);
    color: var(--text-primary-dark);
    padding: 1rem;
  }

  .youtube-video {
    background: black;
    ${(props) => (!props.youtubeVisible ? "width: 0" : "")}
  }

  .switch-content {
    color: var(--accent-primary-light);
  }

  .send-button {
    color: var(--primary-light);
    background: var(--secondary-dark);
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 99em;
  }

  .slidepanel-controls {
    background: var(--primary-dark);
    color: var(--secondary-dark);
    height: fit-content;
    border-radius: 0.5em;

    .fas {
      :hover {
        transform: scale(1.2);
      }
    }
  }
`;

export const SidePanel = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => (props.selected === "notes" ? `background-image: url(${backgroundImg});` : "")}
  background-repeat: repeat-y;
  background-size: 100% 50%;

  width: var(--panel-width);
  padding: 1rem;

  background-color: var(--primary-light);
  z-index: 2;

  transform: ${(props) => (props.visible ? "translateX(0)" : "translateX(100%)")};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};

  transition: all 0.2s ease-in-out;

  @media (min-width: 768px) {
    position: absolute;
    right: var(--sidebar-width) !important;
    border-radius: 2em 0 0 2em;
    height: 100%;
    right: 0;
  }

  @media (max-width: 768px) {
    position: absolute;
    height: 90vh;
    top: 0;
  }

  .tab-content {
    height: 100%;
  }

  .tab-pane {
    height: 100%;
    border-radius: 0.5em 0 0 0;
  }

  .nav-tabs {
    border-bottom: none;
  }

  .nav-link {
    border: none;
    background-color: var(--secondary-light);
    color: var(--text-secondary-light);
    border-radius: 99em;
    margin: 0.5em !important;
    padding: 0.5em 2em 0.5em 2em !important;
  }

  .nav-link.active {
    background-color: var(--accent-primary-light);
    color: var(--text-secondary-light);
    padding: 0.5em 2em 0.5em 2em;
  }

  .content-row {
    overflow-y: scroll;
  }
`;

export const Reaction = styled.i`
  position: absolute;
  left: ${(props) => props.left};
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  color: ${(props) => props.color};
`;

export const SReactions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  margin: auto auto auto auto;

  padding: 0.6rem 1.5rem;
  border-radius: 99em;

  color: rgb(var(--text-primary-dark-rgb), 0.3);
  border: 0.3rem solid rgba(var(--primary-dark-rgb), 0.3);
  background: rgba(var(--secondary-dark-rgb), 0.4);

  :hover {
    color: rgb(var(--text-primary-dark-rgb), 1);
    border: 0.3rem solid rgba(var(--primary-dark-rgb), 1);
    background: rgba(var(--secondary-dark-rgb), 1);
  }

  .reactions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .reactions .clear {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .reactions .reaction {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .reactions .reaction i {
    cursor: pointer;
    margin: 0.5rem;

    :hover {
      transform: scale(1.2);
    }
  }

  .reactions .reaction .description {
    text-align: center;
    font-size: 0.8rem;
    text-transform: uppercase;
  }
`;

export const Sidenav = styled.div`
  border: none;
  z-index: 10;

  color: var(--text-primary-dark);
  background: var(--primary-dark);

  @media (min-width: 768px) {
    position: absolute;
    height: 100%;
    width: 5rem;
    right: 0;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 10vh;
  }

  #sidenav-content {
    width: 5rem;
  }

  .menu-bars {
    background: rgba(var(--secondary-dark-rgb), 1);
    margin: 1.5rem 0 0.2rem 1.5rem;
  }

  .logo {
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    padding: 0.5rem 0 0.5rem 0;
    cursor: pointer;
  }

  .logo img {
    height: 1.7rem;
  }

  .lecture-type {
    color: #f45058;
  }

  .menu {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    color: var(--text-primary-dark);
    background: var(--primary-dark);

    @media (min-width: 768px) {
      flex-direction: column;
    }
  }

  .menu-item {
    all: unset;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.5rem 0 0.5rem 0;
    cursor: pointer;
    width: 100%;
  }

  .menu-item.slides {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .nav-reactions {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .menu-item.active {
    color: var(--accent-primary-dark);

    :hover {
      color: var(--accent-primary-dark);
    }
  }

  .menu-item i {
    font-size: 1.5rem;
  }

  .menu-item:hover {
    color: var(--text-primary-dark);
    background: rgba(var(--secondary-dark-rgb), 0.2);

    i,
    span {
      transform: scale(1.2);
    }
  }

  .menu-item span {
    padding-top: 0.2rem;
    font-size: 0.8rem;
  }

  transition: all 0.2s ease-in-out;
`;

export const FeedbackControls = styled.div`
  position: absolute;

  @media (max-width: 768px) {
    bottom: 10vh;
    right: 0;
  }

  @media (min-width: 768px) {
    bottom: 3rem;
    right: calc(var(--sidebar-width) + 1rem ${(props) => props.panelVisible && " + var(--panel-width)"});
  }

  transition: all 0.2s ease-in-out;
  z-index: 1;
`;
